module.exports = "<app-godown-menu></app-godown-menu>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Godown/Godown.component.html
// module id = ./src/app/Godown/Godown.component.html
// module chunks = main